import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 px-4 text-center border-t border-white/5" data-id="element-148">
      <div className="container mx-auto max-w-3xl" data-id="element-149">
        <h3 className="text-xl font-serif font-bold text-white mb-4 tracking-wider" data-id="element-150">
          🧬 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>

        <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-151">
          El sistema de formación en biodescodificación N°1 para Argentina.
          Porque entender el lenguaje de tu cuerpo no debería postergarse por
          falta de una formación a la altura.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-10 text-sm text-[#eab308]" data-id="element-152">
          <a href="mailto:academiaholisticaargentina@gmail.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-153">
            📧 academiaholisticaargentina@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-154">
            📲 Instagram: @academiaholisticaargentina
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-155">
            📘 Facebook: Academia Holística Argentina
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-4" data-id="element-156">
          <p data-id="element-157">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="font-serif italic text-gray-500 text-sm" data-id="element-158">
            🧬 "El cuerpo habla. Aprendé a escucharlo."
          </p>
        </div>
      </div>
    </footer>;
}